import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/images/right_l.png';

const _withScopeId = n => (_pushScopeId("data-v-7cff34bc"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "superviser-task"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "task-list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "item-title"
};
const _hoisted_6 = {
  key: 0,
  class: "item-status warning"
};
const _hoisted_7 = {
  key: 1,
  class: "item-status success"
};
const _hoisted_8 = {
  key: 2,
  class: "item-status error"
};
const _hoisted_9 = {
  class: "item-name"
};
const _hoisted_10 = {
  class: "item-content"
};
const _hoisted_11 = {
  class: "item-time"
};

const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 任务时间: ");

const _hoisted_13 = {
  class: "item-progress"
};

const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 任务进度: ");

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  title: "已完成评价的教师数/应评价的教师数",
  class: "el-icon",
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202411/8bc19d76dd974e9eab2b0b375c99a4b3.png"
}, null, -1));

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "more-btn"
}, [/*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "//sdauxkdd.zhihuishu.com/admin/1845743177441611776/supervisionTasks"
}, [/*#__PURE__*/_createElementVNode("span", null, "更多"), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})])], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $data.taskList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.menu && _ctx.menu.module_name || '督导任务'), 1), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (item, index) => {
    return _createElementVNode("div", {
      class: "task-item",
      key: index,
      onClick: $event => $options.handleLookDetail(item)
    }, [_createElementVNode("div", _hoisted_5, [item.taskStatus == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, "未开始")) : _createCommentVNode("", true), item.taskStatus == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_7, "进行中")) : _createCommentVNode("", true), item.taskStatus == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_8, "已结束")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, _toDisplayString(item.name) + " " + _toDisplayString(index), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", null, _toDisplayString(item.task_start_time) + "-" + _toDisplayString(item.task_end_time), 1)]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _hoisted_15, _createElementVNode("span", null, _toDisplayString(item.appraise) + "/" + _toDisplayString(item.appraiseAll), 1)])])], 8, _hoisted_4);
  }), 64))]), _hoisted_16])) : _createCommentVNode("", true);
}